import type { PresenceEvent } from '@/types';
import { CONFIG } from '@/config';

type PresenceListener = (event: PresenceEvent) => void;

let intervalId: ReturnType<typeof setInterval> | null = null;
let listeners: PresenceListener[] = [];
let isPresent = false;

/**
 * Mock sensor for laptop development.
 * Simulates presence/absence events randomly.
 */
export function startMockSensor(): void {
  if (intervalId) return;

  console.log('[MockSensor] Started — simulating mmWave presence data');

  intervalId = setInterval(() => {
    // 20% chance of state change each tick
    if (Math.random() < 0.2) {
      isPresent = !isPresent;
    }

    const event: PresenceEvent = {
      timestamp: new Date().toISOString(),
      present: isPresent,
      distance: isPresent ? 0.5 + Math.random() * 2.5 : null,
      audienceCount: isPresent ? Math.ceil(Math.random() * 3) : 0,
    };

    for (const listener of listeners) {
      listener(event);
    }
  }, CONFIG.SENSOR_POLL_INTERVAL_MS);
}

export function stopMockSensor(): void {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
    console.log('[MockSensor] Stopped');
  }
}

export function addPresenceListener(listener: PresenceListener): () => void {
  listeners.push(listener);
  return () => {
    listeners = listeners.filter((l) => l !== listener);
  };
}

export function isRunning(): boolean {
  return intervalId !== null;
}
